import { LoginOption } from "./LoginOption.styles";

export default LoginOption;
